module.exports = __webpack_public_path__ + "img/IMG_9231.89d9df05.jpg";